const storedSessionId = localStorage.getItem("sessionId");

const vkParamName = process.env.REACT_APP_VK_PARAM_NAME || "vk";
const hasVkQuery =
  typeof window !== "undefined" &&
  Boolean(new URLSearchParams(window.location.search).get(vkParamName));

export const initialState = {
  user: storedSessionId ? { sessionId: storedSessionId } : null,
  company: null,
  companyError: null,
  vkBootstrapping: hasVkQuery,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "USER_LOADED":
      return {
        ...state,
        user: action.payload,
      };
    case "COMPANY_LOADED":
      return {
        ...state,
        company: action.payload,
        companyError: null,
      };
    case "COMPANY_LOAD_FAILED":
      return {
        ...state,
        company: null,
        companyError: action.payload ?? "",
      };
    case "VK_BOOTSTRAPPING_SET":
      return {
        ...state,
        vkBootstrapping: Boolean(action.payload),
      };
    default:
      return state;
  }
};
